module.exports = __webpack_public_path__ + "img/antes_despues_257.c178af1e.png";